import Head from "next/head";
import { getGlobalData } from "../utils/api";
import MarketSchedulePageContent from "../components/market-schedule/page-content";
const { getMarketSchedule } = require("../lib/market-schedule");

export default function FindUsPage({ events }) {
  return (
    <>
      <Head>
        <title>Find Goldmallow</title>
        <meta
          name="description"
          content="Find Goldmallow at upcoming Seattle-area events and pop-ups."
        />
        <link rel="canonical" href="https://brownedandtoasted.com/find-us" />
      </Head>
      <MarketSchedulePageContent events={events} />
    </>
  );
}

export async function getStaticProps(context) {
  const locale = context.locale || "en";
  const [globalLocale, events] = await Promise.all([
    getGlobalData(locale),
    getMarketSchedule(undefined, { context: "find-us:getStaticProps" }),
  ]);

  return {
    props: {
      global: globalLocale,
      events,
    },
    revalidate: 300,
  };
}
